import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';
import { Toast } from '@/components';

export const ToastProfileSaved = () => {
    const { t } = useTranslation(['yat_page']);
    const [show, setShow] = useState(false);

    const [searchParams, setSearchParams] = useSearchParams();

    useEffect(() => {
        if (searchParams.has('s')) {
            setShow(true);
            searchParams.delete('s');
            setSearchParams(searchParams);
        }
    }, [searchParams, setShow, setSearchParams]);

    if (show) {
        return <Toast emoji="💎" message={t('edit_profile_toast_saved')} />;
    }

    return null;
};
